// Utilitários para cálculo e validação de proporção de imagens.
//
// A proporção NÃO é armazenada em banco: é sempre calculada a partir das
// dimensões (largura × altura) — tanto da imagem (EmpresaImagem) quanto da
// caixa exigida pelo slot do template de relatório (maxWidth × maxHeight).

/**
 * Formata uma proporção arredondando para o meio (0.5) mais próximo, de modo a
 * exibir ratios "bonitos" (ex: 1:1, 3:1, 4:1, 4.5:1) em vez de decimais "feios"
 * (ex: 0.99:1, 3.01:1). Para imagens retrato (ratio < 1), exibe na forma 1:Y.
 *
 * @param {number} largura
 * @param {number} altura
 * @returns {string} proporção formatada ou '-' quando indisponível
 */
export function formatarProporcao (largura, altura) {
  if (!largura || !altura) return '-'
  const ratio = largura / altura
  if (ratio >= 1) {
    const r = Math.round(ratio * 2) / 2
    return `${Number.isInteger(r) ? r : r.toFixed(1)}:1`
  }
  const inv = Math.round((1 / ratio) * 2) / 2
  return `1:${Number.isInteger(inv) ? inv : inv.toFixed(1)}`
}

/**
 * Verifica se a proporção da imagem atende à proporção exigida pelo slot.
 * A tolerância (0.25) é alinhada ao arredondamento de 0.5 usado na exibição:
 * quando duas proporções aparecem iguais (ex: ambas "3:1"), a validação aceita.
 *
 * @param {number} imgLargura  largura real da imagem
 * @param {number} imgAltura   altura real da imagem
 * @param {number} esperadaLargura  largura exigida pelo slot (slot.maxWidth)
 * @param {number} esperadaAltura   altura exigida pelo slot (slot.maxHeight)
 * @param {number} tolerancia  diferença máxima aceita no ratio (padrão 0.25)
 * @returns {boolean} true quando atende (ou quando faltam dados para validar)
 */
export function proporcaoAtende (imgLargura, imgAltura, esperadaLargura, esperadaAltura, tolerancia = 0.25) {
  if (!imgLargura || !imgAltura || !esperadaLargura || !esperadaAltura) return true
  const esperada = esperadaLargura / esperadaAltura
  const real = imgLargura / imgAltura
  return Math.abs(real - esperada) <= tolerancia
}
